import apiCoreAdapter from "../../../../../hooks/apiCoreAdapter";
import { invalidateSessionsCache } from "../../../../../components/psychologist/calendar/data";

export const getRealSessionId = async (
  sessionId: string,
  sessionDate?: string,
  sessionTime?: string,
  patientEmail?: string,
): Promise<string> => {
  const isTemporaryId =
    sessionId.includes("@") && /^\d{4}-\d{2}-\d{2}-\d{2}:\d{2}-/.test(sessionId);

  if (!isTemporaryId) {
    return sessionId;
  }

  let date: string, time: string, email: string;

  const match = sessionId.match(/^(\d{4}-\d{2}-\d{2})-(\d{2}:\d{2})-(.+)$/);
  if (match) {
    [, date, time, email] = match;
  } else if (sessionDate && sessionTime && patientEmail) {
    date = sessionDate;
    time = sessionTime;
    email = patientEmail;
  } else {
    console.warn("⚠️ No se puede extraer información del ID temporal:", sessionId);
    return sessionId;
  }

  try {
    invalidateSessionsCache();

    const sessionsResp = await apiCoreAdapter.psychologistSessionsList({
      from: `${date} 00:00:00`,
      to: `${date} 23:59:59`,
      take: 100,
      status: "active,incomplete,settled",
    });

    const sessions = Array.isArray(sessionsResp?.data) ? sessionsResp.data : [];

    const matchingSession = sessions.find(
      (s: { date?: string; patients?: Array<{ email?: string }> }) => {
        if (!s.date) return false;

        const sessionDate = s.date.split("T")[0];
        if (sessionDate !== date) return false;

        const sessionTime = s.date.split("T")[1]?.split(":");
        if (sessionTime) {
          const sessionHour = sessionTime[0];
          const sessionMinute = sessionTime[1];
          const [targetHour, targetMinute] = time.split(":");
          if (sessionHour === targetHour && sessionMinute === targetMinute) {
            const patients = Array.isArray(s.patients) ? s.patients : [];
            return patients.some((p: { email?: string }) => p.email === email);
          }
        }
        return false;
      },
    );

    if (matchingSession && matchingSession.id) {
      return String(matchingSession.id);
    } else {
      console.warn("⚠️ No se encontró sesión real para ID temporal:", sessionId);
      throw new Error("No se pudo encontrar la sesión real");
    }
  } catch (error) {
    console.error("Error buscando sesión real:", error);
    throw error;
  }
};
